<template>
  <div class="product-table">
    <div class="title-box primary-box">
      <div class="title-box__back-container">
        <v-icon @click="$router.push('/')">mdi-chevron-left</v-icon>
      </div>
      <div class="title-box__title">
        <h2 itemprop="headline">{{getTranslation(language, 'product-table')}}</h2>
        <h3>Totale: {{ formatCurrency(totalPrice) }} €</h3>
      </div>
    </div>
    
    <v-dialog v-model="showFullScreenImage" transition="dialog-bottom-transition">
      <v-img :src="fullscreenImage" class="fullscreen-img"
          @click="fullscreenImage = null" eager></v-img>
    </v-dialog>
    <v-data-table
      :headers="headers"
      :items="products"
      item-value="name"
      class="elevation-1 table"
      :items-per-page="20"
      hide-default-footer
      density="compact"
    >
      <template v-slot:[`item.thumbnail`]="{ item }">
        <v-img :src="item.img?.formats?.thumbnail?.url" 
        alt="Product image" 
        class="product-thumbnail"
        @click="fullscreenImage = item.img.url"
      ></v-img>
      </template>
      <template v-slot:[`item.name`]="{ item }" >                    
        <span class="text-td">{{ item.name }}</span>
      </template>
      <template v-slot:[`item.price`]="{ item }">                    
        <span class="text-td">{{ formatCurrency(item.price) }}</span>
      </template>
      <template v-slot:[`item.quantity`]="{ item }">
        <v-text-field
          v-model="item.quantity"
          class="quantity-input"
          variant="underlined"
          type="number"
          min="0"
          density="compact"
          step="0.5"
          flat
          style="align-self: center;"
          hide-details
        ></v-text-field>
      </template>
      <template v-slot:[`item.total_price`]="{ item }">                    
        <span class="text-td">{{ formatCurrency(item.price * item.quantity) }}</span>
      </template>
    </v-data-table>
    <div>
      <h2>
        Totale: {{ formatCurrency(totalPrice) }} €
      </h2>
    </div>
    <div class="actions">
      <v-btn @click="saveQuantities" class="primary-btn">{{ getTranslation(language, 'save') }}</v-btn>
      <v-btn @click="clearQuantities" class="primary-btn">{{ getTranslation(language, 'reset') }}</v-btn>
    </div>
  </div>
</template>

<script>
import apiService from "@/services/ApiService";
import {getTranslation} from "@/services/stringTableService";

export default {
  name: "ProductTable",
  data() {
    return {
      headers: [
        { text: "Thumbnail", value: "thumbnail" },
        { text: "Name", value: "name" },
        { text: "Price", value: "price" },
        { text: "Quantity", value: "quantity" },
        { text: "Total Price", value: "total_price" },
      ],
      products: [],      
      fullscreenImage: null,
      language: 'IT'
    };
  },
  async created() {
    await this.fetchProducts();
    this.loadQuantities();
  },
  computed: {
    formatCurrency() {
      return (value) => {        
        return value.toFixed(2);
      };
    },
    totalPrice() {
      return this.products.reduce((acc, product) => {
        return acc + product.price * product.quantity;
      }, 0);
    },
    showFullScreenImage() {
      return this.fullscreenImage != null;
    }
  },
  methods: {
    getTranslation,
    async fetchProducts() {
      try {
        this.$store.dispatch("setLoading", true);
        const products = await apiService.getProducts();
        this.products = products.map((product) => ({
          ...product,
          quantity: product.quantity || 0,
        }));
      } catch (error) {
        console.error(error);
      } finally {
        this.$store.dispatch("setLoading", false);
      }
    },
    saveQuantities() {
      const quantities = this.products.map(product => ({ id: product.id, quantity: product.quantity }));
      localStorage.setItem('productQuantities', JSON.stringify(quantities));
    },
    clearQuantities() {
      this.products.forEach(product => {
        product.quantity = 0;
      });
      localStorage.removeItem('productQuantities');
    },
    loadQuantities() {
      const quantities = JSON.parse(localStorage.getItem('productQuantities'));
      if (quantities) {
        this.products.forEach(product => {
          const savedProduct = quantities.find(q => q.id === product.id);
          if (savedProduct) {
            product.quantity = savedProduct.quantity;
          }
        });
      }
    }
  }
};
</script>

<style scoped lang="scss">
@import "../style/_variables.scss";

.product-table {    
  text-align: center;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  width: 100%;
  background-color: $secondary-background-color;
  .table {
    margin-top: 20px;
    background-color: $background-color;
    color: $text-color;
    max-width: 800px;
    .table_title {
      background: $primary-gradient;
    }
  }
  .quantity-input {
    max-width: 80px;
    min-width: 40px;
  }
  .text-td {
    font-size: 0.8rem;
    line-height: 0.8rem;
  }
  .actions {
    display: flex;
    justify-content: center;
    margin-top: 20px;
    gap: 20px;
    flex-wrap: wrap;
  }
}

.product-thumbnail {
  width: 40px;
  cursor: pointer;
}
</style>
